// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { v4 } from 'uuid';
import { Icon } from "../Icon";
function hasSeparator(index, l) {
  return index < l - 1;
}
var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var label = _ref.label,
    href = _ref.href,
    active = _ref.active;
  return /*#__PURE__*/React.createElement("li", {
    className: ['cop-ounded-xs', 'cop-cursor-pointer', 'cop-px-1', 'cop-py-[2px]', active ? 'cop-text-primary' : 'cop-text-secondary', !active ? 'hover:cop-bg-primary' : ''].join(' ')
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    className: ['cop-no-underline', 'cop-text-sm', active ? 'cop-text-primary' : 'cop-text-secondary'].join(' ')
  }, label));
};
export var Breadcrumbs = function Breadcrumbs(_ref2) {
  var items = _ref2.items,
    _ref2$separator = _ref2.separator,
    separator = _ref2$separator === void 0 ? 'ChevronRight' : _ref2$separator;
  var itemsWithIdsSet = new Set(items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: v4()
    });
  }));
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "breadcrumb",
    className: "cop-w-full"
  }, /*#__PURE__*/React.createElement("ol", {
    className: "cop-flex cop-list-none cop-items-center cop-gap-3 cop-p-0"
  }, Array.from(itemsWithIdsSet).map(function (_ref3, index) {
    var label = _ref3.label,
      href = _ref3.href,
      active = _ref3.active,
      id = _ref3.id;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbItem, {
      key: id,
      label: label,
      href: href,
      active: active
    }), hasSeparator(index, items.length) && /*#__PURE__*/React.createElement(Icon, {
      icon: separator,
      key: index,
      className: "cop-w-[0.5rem]"
    }));
  })));
};
